// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"431":"d5d38d1a","455":"6d14eb31"}[chunkId] + ".chunk.js";
};